import {
  Box,
  CardContent,
  FormControl,
  FormLabel,
  capitalize,
  MenuItem,
  Select,
} from '@mui/material';
import { CloudAccountType, Provider } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { PanelWrapper } from '@/components/panels/panelWrapper';
import { useWorkspace } from '@/contexts/useWorkspace';
import { CloudProviders } from '@/data/inventory/data';

import { CreateAWSAccountPanel } from './cloudAccountAWSPanel';
import CreateAzureAccountPanel from './cloudAccountAzurePanel';
import CreateGcpAccountPanel from './cloudAccountGcpPanel';

export const CreateAccountPanel = ({
  accountType,
  allowedCloudProviders,
  onCreated,
}: {
  accountType: CloudAccountType;
  allowedCloudProviders: Provider[];
  onCreated: () => void;
}) => {
  const { rightPanel } = useWorkspace();
  const [cloudProvider, setCloudProvider] = useState(allowedCloudProviders[0]);
  const [loading, setLoading] = useState(false);

  const { setIsOpen } = rightPanel;
  const onClose = () => setIsOpen(false);
  const headerTitle = CloudAccountType.Source
    ? `Connect ${capitalize(accountType.toLowerCase())}`
    : CloudAccountType.Scanning
      ? 'Connect Backup Account'
      : `Connect ${capitalize(accountType.toLowerCase())} Account`;

  return (
    <PanelWrapper rounded header={{ title: headerTitle, onClose }}>
      <CardContent>
        {allowedCloudProviders.length > 1 && (
          <Box className='flex flex-col justify-center mx-[20px] my-[30px] gap-[8px]'>
            <FormControl size='small'>
              <FormLabel>Cloud provider</FormLabel>
              <Select
                value={cloudProvider}
                disabled={loading}
                onChange={(event) =>
                  setCloudProvider(event.target.value as Provider)
                }
                sx={{
                  height: '48px',
                  mb: '12px',
                }}
              >
                <MenuItem
                  value={Provider.Aws}
                  disabled={!allowedCloudProviders?.includes(Provider.Aws)}
                >
                  {CloudProviders[Provider.Aws].displayName}
                </MenuItem>
                <MenuItem
                  value={Provider.Azure}
                  disabled={!allowedCloudProviders?.includes(Provider.Azure)}
                >
                  {CloudProviders[Provider.Azure].displayName}
                </MenuItem>
                <MenuItem
                  value={Provider.Gcp}
                  disabled={!allowedCloudProviders?.includes(Provider.Gcp)}
                >
                  {CloudProviders[Provider.Gcp].displayName}
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
        {cloudProvider === Provider.Aws && (
          <CreateAWSAccountPanel
            accountType={accountType}
            onCreated={onCreated}
            setLoading={setLoading}
          />
        )}
        {cloudProvider === Provider.Azure && (
          <CreateAzureAccountPanel
            accountType={accountType}
            onCreated={onCreated}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {cloudProvider === Provider.Gcp && (
          <CreateGcpAccountPanel
            accountType={accountType}
            onCreated={onCreated}
            loading={loading}
            setLoading={setLoading}
          />
        )}
      </CardContent>
    </PanelWrapper>
  );
};
